// extracted by mini-css-extract-plugin
export default {"sinCiudades":"Cards_sinCiudades__WGavD","fadeinout":"Cards_fadeinout__cpCzP","cards":"Cards_cards__D4nf1","nubes":"Cards_nubes__8HS8r"};